export default __webpack_public_path__ + "static/media/prancha.22dd65db.png";